//
// JToast.js
//

class JToast {
    constructor(data) {
        this._data = data?.JTurn?.JToast ?? [];
    }

    createElement(message) {
        const toast = document.createElement('div');
        toast.classList.add('toast');
        toast.setAttribute('role', 'alert');
        toast.setAttribute('aria-live', 'assertive');
        toast.setAttribute('aria-atomic', 'true');

        const body = document.createElement('div');
        body.classList.add('toast-body');
        body.innerHTML = message;

        toast.appendChild(body);

        return toast;
    }

    run() {
        const wrapper = document.querySelector('.toast-container');

        for (const item of this._data) {
            const options = {
                autohide: item.autohide,
                delay: item.delay
            };

            const element = this.createElement(item.message);
            wrapper.appendChild(element);

            const instance = new Toast(element, options);
            instance.show();

            element.addEventListener('hidden.bs.toast', () => {
                element.remove();
            });
        }
    }
}

// Make available globally
window.JToast = JToast;